export default {
    slug: 'clear-aligners',
    img: '/img/tr-aligners.jpg',
    icon: 'aligners',
    en: {
        name: 'Clear Aligners',
        short: 'A more discreet orthodontic option, planned around your life.',
        metaTitle: 'Clear Aligners in Johor Bahru | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Clear aligner treatment in Johor Bahru for local patients and patients travelling from Singapore and Indonesia. Honest suitability, clear planning, transparent fees.',
        kicker: 'Orthodontics',
        heroTitle: 'Clear aligners in Johor Bahru — planned around your life, even when you live abroad.',
        heroSub: 'Clear aligners are a discreet, removable way to move teeth. They are not suitable for everyone — and we will tell you honestly whether they are suitable for you.',
        whoIntro: 'Aligners may be considered for:',
        who: [
            'Adults and older teenagers who want a more discreet option than fixed braces',
            'Patients whose clinical condition is suitable for aligner treatment — confirmed only after assessment',
            'Patients travelling from Singapore or Indonesia who want reviews planned around travel',
        ],
        problem: 'Clear aligners are removable, transparent trays that move teeth step by step. They address many — but not all — orthodontic problems, and they demand daily wear discipline. Suitability is confirmed after assessment, never assumed.',
        assessmentIntro: 'How we assess:',
        assessment: [
            'An examination of teeth, bite and oral health',
            'Records where clinically needed',
            'An honest discussion: are aligners the right tool for your case?',
            'A treatment plan and fee breakdown in writing before you decide',
        ],
        optionsIntro: 'The choices we discuss at assessment:',
        options: [
            { name: 'Clear aligner treatment', text: 'A series of aligners worn in order, changed step by step under clinical review. Daily wear discipline is the patient\u2019s part of the deal.' },
            { name: 'Not suitable? Then what?', text: 'If aligners are not the right fit for your clinical condition, we will tell you — and explain what is.' },
        ],
        knowIntro: 'What patients should know:',
        know: [
            'Aligners work only when worn as directed — daily wear discipline is essential',
            'Reviews are planned roughly every 3 months where clinically appropriate; many patients combine visits with a trip to Johor Bahru',
            'If an aligner is lost, replacement may be arranged by courier where appropriate — subject to clinic/provider terms and applicable delivery requirements',
            'Fees and inclusions are explained in writing before treatment begins',
        ],
        followup: 'Review visits monitor progress and issue aligner stages. Between visits, the clinic stays reachable on WhatsApp for practical questions.',
        faqs: [
            { q: 'Are clear aligners suitable for me?', a: 'That depends on your clinical condition — aligners address many problems but not all. The assessment decides, never the advertisement.' },
            { q: 'How often will I need reviews?', a: 'Where clinically appropriate, reviews are planned approximately every 3 months. Your actual schedule is set by your doctor based on your treatment plan.' },
            { q: 'What happens if I lose an aligner?', a: 'Contact the clinic. Replacement aligners may be couriered where appropriate — subject to clinic/provider terms and applicable delivery requirements, which we confirm with you before treatment.' },
            { q: 'I live in Singapore / Batam. Can I do this treatment in JB?', a: 'Many international patients do. See our Singapore and Indonesia/Batam pages for how cross-border care is structured.' },
        ],
        intlNote: 'Clear aligners are the hero treatment for our international patients — see the Singapore or Indonesia/Batam pages for how cross-border care is structured.',
        teenNote: 'For teenagers, aligners depend on daily discipline. Some teens do brilliantly; for others, fixed braces are the more honest choice. We will say which at assessment.',
    },
    ms: {
        name: 'Clear Aligners',
        short: 'Pilihan ortodontik yang lebih halus, dirancang mengikut hidup anda.',
        metaTitle: 'Clear Aligners di Johor Bahru | Klinik Pergigian Irma Ariandi',
        metaDesc: 'Rawatan clear aligner di Johor Bahru untuk pesakit tempatan dan pesakit dari Singapura serta Indonesia. Kesesuaian jujur, perancangan jelas, yuran telus.',
        kicker: 'Ortodontik',
        heroTitle: 'Clear aligners di Johor Bahru — dirancang mengikut hidup anda, walaupun anda tinggal di luar negara.',
        heroSub: 'Clear aligners ialah cara yang lebih halus dan boleh dibuka untuk menggerakkan gigi. Ia tidak sesuai untuk semua orang — dan kami akan beritahu dengan jujur sama ada ia sesuai untuk anda.',
        whoIntro: 'Aligners mungkin dipertimbangkan untuk:',
        who: [
            'Dewasa dan remaja yang lebih matang yang mahukan pilihan lebih halus daripada braces tetap',
            'Pesakit yang keadaan klinikalnya sesuai untuk aligner — disahkan hanya selepas penilaian',
            'Pesakit dari Singapura atau Indonesia yang mahu review dirancang mengikut perjalanan',
        ],
        problem: 'Clear aligners ialah susunan bekas lut sinar yang boleh dibuka, yang menggerakkan gigi langkah demi langkah. Ia menangani banyak — tetapi bukan semua — masalah ortodontik, dan memerlukan disiplin pemakaian harian. Kesesuaian disahkan selepas penilaian, bukan diandaikan.',
        assessmentIntro: 'Bagaimana kami menilai:',
        assessment: [
            'Pemeriksaan gigi, gigitan dan kesihatan mulut',
            'Rekod di mana perlu secara klinikal',
            'Perbincangan yang jujur: adakah aligner alat yang betul untuk kes anda?',
            'Pelan rawatan dan rincian yuran secara bertulis sebelum anda memutuskan',
        ],
        optionsIntro: 'Pilihan yang kami bincangkan pada penilaian:',
        options: [
            { name: 'Rawatan clear aligner', text: 'Siri aligner dipakai mengikut turutan, ditukar langkah demi langkah di bawah review klinikal. Disiplin pemakaian harian ialah tanggungjawab pesakit.' },
            { name: 'Tidak sesuai? Kemudian?', text: 'Jika aligner bukan yang sesuai untuk keadaan klinikal anda, kami beritahu — dan terangkan apa yang sesuai.' },
        ],
        knowIntro: 'Apa yang pesakit patut tahu:',
        know: [
            'Aligner hanya berkesan jika dipakai mengikut arahan — disiplin harian adalah penting',
            'Review dirancang kira-kira setiap 3 bulan di mana sesuai secara klinikal; ramai pesakit menggabungkan lawatan dengan trip ke Johor Bahru',
            'Jika aligner hilang, penggantian boleh diatur melalui kurier di mana sesuai — tertakluk kepada terma klinik/pembekal dan keperluan penghantaran',
            'Yuran dan apa yang termasuk diterangkan secara bertulis sebelum rawatan bermula',
        ],
        followup: 'Lawatan review memantau kemajuan dan mengeluarkan siri aligner seterusnya. Antara lawatan, klinik kekal boleh dihubungi melalui WhatsApp.',
        faqs: [
            { q: 'Adakah clear aligners sesuai untuk saya?', a: 'Itu bergantung pada keadaan klinikal anda — aligner menangani banyak masalah tetapi bukan semua. Penilaian yang menentukan, bukan iklan.' },
            { q: 'Berapa kerap saya perlu review?', a: 'Di mana sesuai secara klinikal, review dirancang kira-kira setiap 3 bulan. Jadual sebenar anda ditetapkan oleh doktor berdasarkan pelan rawatan anda.' },
            { q: 'Apa yang berlaku jika aligner hilang?', a: 'Hubungi klinik. Aligner pengganti boleh dikurier di mana sesuai — tertakluk kepada terma klinik/pembekal dan keperluan penghantaran, yang kami sahkan sebelum rawatan.' },
            { q: 'Saya tinggal di Singapura / Batam. Boleh buat rawatan ini di JB?', a: 'Ramai pesakit antarabangsa melakukannya. Lihat halaman Singapura dan Indonesia/Batam kami untuk struktur rawatan lintas sempadan.' },
        ],
        intlNote: 'Clear aligners ialah rawatan utama pesakit antarabangsa kami — lihat halaman Singapura atau Indonesia/Batam untuk struktur rawatan lintas sempadan.',
        teenNote: 'Untuk remaja, aligner bergantung pada disiplin harian. Sebilangan remaja sangat berjaya; untuk yang lain, braces tetap lebih jujur. Kami sebutkan pada penilaian.',
    },
    zh: {
        name: '隐形牙套',
        short: '更美观隐蔽的正畸选择，围绕您的生活安排。',
        metaTitle: '新山隐形牙套（Clear Aligners）| Irma Ariandi 牙科诊所',
        metaDesc: '新山隐形牙套治疗 —— 本地患者及来自新加坡、印尼的患者。诚实的适合性评估、清楚的治疗规划、透明的收费。',
        kicker: '正畸治疗',
        heroTitle: '在新山做隐形牙套 —— 围绕您的生活规划，即使您住在国外。',
        heroSub: '隐形牙套是一种美观、可摘戴的矫正方式。它并非适合所有人 —— 我们会诚实地告诉您它是否适合您。',
        whoIntro: '可能考虑隐形牙套的情况：',
        who: [
            '想要比固定牙套更美观选择的成人及较成熟的青少年',
            '临床条件适合隐形牙套的患者 —— 仅在评估后确认',
            '从新加坡或印尼过来、希望复诊配合行程的患者',
        ],
        problem: '隐形牙套是一系列透明、可摘戴的牙套，逐步移动牙齿。它处理许多 —— 但非全部 —— 正畸问题，并且需要每天的佩戴自律。适合与否由评估确认，绝不由广告假设。',
        assessmentIntro: '我们的评估包括：',
        assessment: [
            '牙齿、咬合与口腔健康检查',
            '临床需要时拍摄记录',
            '诚实的讨论：隐形牙套是否是您案例的正确工具？',
            '在您决定之前，书面提供治疗方案与费用明细',
        ],
        optionsIntro: '评估时讨论的选择：',
        options: [
            { name: '隐形牙套治疗', text: '按顺序佩戴、逐步更换的一系列牙套，在临床复诊监督下进行。每日坚持佩戴是患者需要配合的部分。' },
            { name: '不适合怎么办？', text: '如果您的临床情况不适合隐形牙套，我们会如实告知 —— 并解释适合的方案。' },
        ],
        knowIntro: '患者须知：',
        know: [
            '按指示佩戴才有效 —— 每天的佩戴自律至关重要',
            '在临床条件合适的情况下，复诊约每 3 个月安排一次；许多患者会把复诊与赴新山的行程结合',
            '如果牙套遗失，在条件允许时可安排快递补发 —— 需视乎诊所/供应商条款及配送要求',
            '费用与包含内容在治疗前书面说明',
        ],
        followup: '复诊跟进进度并发放下一阶段牙套。复诊之间，诊所可通过 WhatsApp 联系。',
        faqs: [
            { q: '隐形牙套适合我吗？', a: '取决于您的临床条件 —— 它能处理许多但非全部问题。由评估决定，而不是广告。' },
            { q: '多久需要复诊一次？', a: '在临床条件合适的情况下约每 3 个月一次。实际安排由医生根据治疗方案确定。' },
            { q: '牙套丢了怎么办？', a: '联系诊所。条件允许时可快递补发 —— 需视乎诊所/供应商条款及配送要求，治疗前会与您确认。' },
            { q: '我住在新加坡 / 巴淡岛，可以在新山做吗？', a: '许多国际患者都在做。请查看新加坡与印尼/巴淡岛专页了解跨境就诊安排。' },
        ],
        intlNote: '隐形牙套是我们国际患者的主要治疗 —— 请查看新加坡或印尼/巴淡岛专页。',
        teenNote: '对青少年而言，隐形牙套依赖每天自律。有的做得很好；对另一些孩子，固定牙套是更诚实的选择。评估时我们会明说。',
    },
    ta: {
        name: 'Clear Aligners',
        short: 'குறைவாகத் தெரியும் அழகியல் தீர்வு.',
        metaTitle: 'ஜொகூர் பாருவில் Clear Aligners | இர்மா அரியாண்டி பல் கிளினிக்',
        metaDesc: 'ஜொகூர் பாருவில் clear aligner சிகிச்சை — உள்ளூர் மற்றும் சிங்கப்பூர், இந்தோனேசியா நோயாளிகளுக்கு.',
        kicker: 'பற்கள் நேர்த்தி',
        heroTitle: 'ஜொகூர் பாருவில் clear aligners — உங்கள் வாழ்க்கைக்கு ஏற்பத் திட்டமிடப்படுகிறது.',
        heroSub: 'Clear aligners ஒரு குறைவாகத் தெரியும், அகற்றக்கூடிய தீர்வு. இது அனைவருக்கும் பொருந்தாது — உங்களுக்குப் பொருந்துமா என்று நேர்மையாகச் சொல்வோம்.',
        whoIntro: 'கருத்தில் கொள்ளக்கூடியவர்கள்:',
        who: [
            'நிலையான பிரேசஸை விட குறைவாகத் தெரியும் தீர்வு விரும்புவோர்',
            'மருத்துவ ரீதியாகப் பொருத்தமான நோயாளிகள்',
            'சிங்கப்பூர் / இந்தோனேசியாவிலிருந்து வருவோர்',
        ],
        problem: 'Clear aligners படிப்படியாகப் பற்களை நகர்த்தும் நீக்கக்கூடிய கண்ணாடி அடுக்குகள். தினசரி ஒழுங்கு அவசியம். பொருத்தம் மதிப்பீட்டிற்குப் பிறகே உறுதியாகும்.',
        assessmentIntro: 'எங்கள் மதிப்பீடு:',
        assessment: [
            'பற்கள், கடித்தல், வாய் ஆரோக்கியப் பரிசோதனை',
            'நேர்மையான உரையாடல்: உங்களுக்கு aligner பொருத்தமா?',
            'முடிவெடுப்பதற்கு முன்பே எழுத்துப்பூர்வ கட்டண விளக்கம்',
        ],
        optionsIntro: 'மதிப்பீட்டில் விவாதிக்கும் விருப்பங்கள்:',
        options: [
            { name: 'Clear aligner சிகிச்சை', text: 'வரிசையாக அணியும், படிப்படியாக மாற்றப்படும் aligner-கள்; மருத்துவ மறிப்பாய்வின் கீழ். தினசரி அணியும் ஒழுக்கம் நோயாளியின் பங்கு.' },
            { name: 'பொருத்தமில்லை என்றால்?', text: 'உங்கள் மருத்துவ நிலைக்கு aligners பொருந்தாவிட்டால், நேர்மையாகச் சொல்வோம் — பொருத்தமானதை விளக்குவோம்.' },
        ],
        knowIntro: 'நோயாளிகள் அறிந்திருக்க வேண்டியவை:',
        know: [
            'வழிமுறைப்படி அணிந்தால் மட்டுமே பலன்',
            'மருத்துவ ரீதியாகப் பொருந்தினால் சுமார் 3 மாதங்களுக்கு ஒருமுறை மதிப்பாய்வு',
            'Aligner இழப்பால் நிபந்தனைகளுக்கு உட்பட்டு குரியர் மூலம் மாற்று சாத்தியம்',
            'கட்டணம் சிகிச்சைக்கு முன்பே எழுத்தில் விளக்கம்',
        ],
        followup: 'வருகைகளுக்கு இடையில் WhatsApp மூலம் கிளினிக் தொடர்பில் இருக்கும்.',
        faqs: [
            { q: 'எனக்கு clear aligners பொருத்தமா?', a: 'உங்கள் மருத்துவ நிலையைப் பொறுத்தது — மதிப்பீட்டில் முடிவெடுக்கப்படும்.' },
            { q: 'எவ்வளவு பார்வைகள்?', a: 'பொருந்தினால் சுமார் 3 மாதங்களுக்கு ஒருமுறை; உண்மையான காலவரிசை மருத்துவரால் தீர்மானிக்கப்படும்.' },
            { q: 'சிங்கப்பூர் / பத்தாமில் வசிக்கிறேன், ஜொகூரில் செய்யலாமா?', a: 'பல சர்வதேச நோயாளிகள் செய்கிறார்கள். சிங்கப்பூர் / இந்தோனேசியா பக்கங்களைப் பாருங்கள்.' },
        ],
        intlNote: 'சர்வதேச நோயாளிகளுக்கு clear aligners தான் முக்கிய சிகிச்சை — சிங்கப்பூர் / இந்தோனேசியா பக்கங்களைப் பாருங்கள்.',
        teenNote: 'பதின்ம வயதினருக்கு aligners தினசரி ஒழுங்கைச் சார்ந்தது. மதிப்பீட்டில் நேர்மையாகச் சொல்வோம்.',
    },
};
